import {CommonContractorCreateUpdateApp} from "../../../../Dashboard/Contractors/Functionality/ContractorCreateUpdateFlows/CommonContractorCreateUpdateApp";
import {permissionObj} from "../../../../../Helpers/permission";
import routes from "../../../../../Routes/routes";
import HeadTittle from "../../../../../components/HeadTittle";
import ManagerFields from "../../../../Dashboard/Contractors/SubComponents/ContractorCreateUpdateFlows/ManagerFields";
import React from "react";
import {EmployeeFlowSupplierCreateApp} from "../../Funtionality/SupplierCreateUpdateFlows/EmployeeFlowSupplierCreateApp";
import SupplierCompanyFields from "./SupplierCompanyFields";
import StepperTabs from "../../../../../components/StepperTabs/StepperTabs";
import StepTab from "../../../../../components/StepperTabs/StepTab";
import {ButtonNextStep, ButtonPrevStep} from "../../../../../components/buttons/ButtonNavigation";
import CustomPhotoPicker from "../../../../../components/PhotoPicker/CustomPhotoPicker";
import {ACTION_MODEL} from "../../../../../Helpers/ActionModel";
import {FILE_TYPE} from "../../../../../Helpers/fileType";
import {SUGGESTION_MODE_OPTION} from "../../../../../components/PhotoPicker/SubComponent/Models/Models";
import CopySecretModal from "../../../../Dashboard/Company/Employees/Modal/CopySecretModal";
import {STEPS_PROVIDER_CREATE, TABS_PROVIDER} from "../../../Model/Model";
import SupplierSummary from "./SupplierSummary";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */
const EmployeeFlowSupplierCreate = () => {

    const props = CommonContractorCreateUpdateApp();

    const {
        t,
        dispatch,
        navigate,
        DEV,
        permission,
        isValidEmail,
        isValidPassword,
        isValidPhoneNumber,
        isValidDob,
        setIsValidDob,
        isValidDocumentId,
        setIsValidDocumentId,
        userInfoStatusList,
        emptyFields,
        setEmptyFields,
        setIsValidEmail,
        setIsValidPhoneNumber,
        handleDateChange,
        handleEmailChange,
        handlePhoneNumberChange,
        validateEmail,
        validatePhone,
        handlePasswordChange,
        secretModal,
        setSecretModal,
        secretKey,
        setSecretKey,
        generatedPassword,
        setGeneratedPassword,
        passwordGenerator,
        disabled,
        activeStep,
        setActiveStep,
        steps,
        setSteps,

        handleStepChange,
        photoPicker,
        setPhotoPicker

    }  = props;

    const {
        user,
        setUser,
        FormHandler,
        resetForm,
        getAllServiceType,
        handleValidateSteps,
        handleOnBack
    } = EmployeeFlowSupplierCreateApp({
        t,
        dispatch,
        navigate,
        emptyFields,
        setEmptyFields,
        isValidDob,
        photoPicker,
        setPhotoPicker,
        permission,
        setIsValidEmail,
        setIsValidPhoneNumber,
        isValidPassword,
        setSecretModal,
        setSecretKey,
        setGeneratedPassword,
        passwordGenerator,
        setSteps
    });

    if(!DEV && (!permission?.includes(permissionObj.WEB_SUPPLIER_READ)
        || !permission?.includes(permissionObj.WEB_SUPPLIER_CREATE))) navigate(routes.forbidden);

    return (
        <>
            <HeadTittle
                onBack={handleOnBack}
                name={t("create")}
            />

            <StepperTabs id={null} disabled={false} steps={steps} activeStep={activeStep} isStepOptional={() => { }}
                         setActiveStep={setActiveStep} handleStepChange={handleStepChange}
            >
                <StepTab index={STEPS_PROVIDER_CREATE.COMPANY_DETAILS} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_PROVIDER_CREATE.COMPANY_DETAILS &&
                    <>
                        <SupplierCompanyFields
                            user={user}
                            setUser={setUser}
                            emptyFields={emptyFields}
                            resetForm={() => resetForm(0)}
                            getAllServiceType={getAllServiceType}
                        />

                        <div className='col-sm-12 col-xxl-6 col-lg-6 offset-xxl-6 offset-lg-6 mb-60px'>
                            <ButtonNextStep
                                id='btn_efsc_next_company_fields'
                                text='next'
                                click={() => {
                                    if (handleValidateSteps(activeStep)) {
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }
                                }}
                            />
                        </div>
                    </>
                    }
                </StepTab>
                <StepTab index={STEPS_PROVIDER_CREATE.MANAGER_DETAILS} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_PROVIDER_CREATE.MANAGER_DETAILS &&
                    <>
                        <ManagerFields
                            title={"manager"}
                            user={user}
                            setUser={setUser}
                            emptyFields={emptyFields}
                            isValidDocumentId={isValidDocumentId}
                            setIsValidDocumentId={setIsValidDocumentId}
                            isValidEmail={isValidEmail}
                            handlePasswordChange={handlePasswordChange}
                            isValidPhoneNumber={isValidPhoneNumber}
                            isValidDob={isValidDob}
                            setIsValidDob={setIsValidDob}
                            handleEmailChange={handleEmailChange}
                            handlePhoneNumberChange={handlePhoneNumberChange}
                            handleDateChange={handleDateChange}
                            statusList={userInfoStatusList}
                            handleClearAll={()=>{
                                resetForm(activeStep);
                            }}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                            <ButtonPrevStep
                                id='btn_efs_back_manage_fields'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_efs_next_manage_fields'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => {
                                    if (handleValidateSteps(activeStep)) {
                                        setActiveStep((prevStep) => prevStep + 1);
                                    }
                                }}
                            />
                        </div>
                    </>
                    }
                </StepTab>
                <StepTab index={STEPS_PROVIDER_CREATE.ADD_PHOTO} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_PROVIDER_CREATE.ADD_PHOTO &&
                    <>
                        <CustomPhotoPicker
                            id='fp_efs_create_photo_profile'
                            photoPicker={photoPicker}
                            setPhotoPicker={setPhotoPicker}
                            actionModel={ACTION_MODEL.CREATE}
                            accept={{ ...FILE_TYPE.IMAGE_FACE_VALIDATION }}
                            showBtnCamera={true}
                            validateFace={true}
                            classWith={'content-center-w-400px mt-4'}
                            showPreview={true}
                            disabled={disabled}
                            typeSuggestions={SUGGESTION_MODE_OPTION.SELFIE} // It is required if showBtnCamera is true
                        />
                        <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                            <ButtonPrevStep
                                id='btn_efs_back_photo_picker'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_efs_next_photo_picker'
                                text='next'
                                disabled={activeStep === steps.length - 1}
                                click={() => {
                                    setActiveStep((prevStep) => prevStep + 1);
                                }}
                            />
                        </div>
                    </>
                    }
                </StepTab>
                <StepTab index={STEPS_PROVIDER_CREATE.SUMMARY} activeStep={activeStep} normalHeight={true}>
                    {activeStep === STEPS_PROVIDER_CREATE.SUMMARY &&
                    <>
                        <SupplierSummary
                            user={user}
                            photoPicker={photoPicker}
                            getAllServiceType={getAllServiceType}
                        />
                        <div className='col-12 d-flex justify-content-between mt-3 mb-60px'>
                            <ButtonPrevStep
                                id='btn_efs_back_summary'
                                text='back'
                                click={() => setActiveStep((prevStep) => prevStep - 1)}
                            />
                            <ButtonNextStep
                                id='btn_efs_enroll_contractor'
                                text='create'
                                click={() => {
                                    validateEmail(user.email);
                                    validatePhone(user.phoneNumber);
                                    FormHandler();
                                }}
                            />
                        </div>
                    </>
                    }
                </StepTab>
            </StepperTabs>

            <CopySecretModal
                show={secretModal}
                setShow={setSecretModal}
                secret={secretKey}
                setSecret={setSecretKey}
                setData={setUser}
                generatedPassword={generatedPassword}
                onHide={() => {
                    navigate(routes.suppliers.main, {
                        state: {currentTab:TABS_PROVIDER.SUPPLIERS.INDEX}
                    });
                }}
                closeText={'continue'}
            />
        </>
    );
};
export default EmployeeFlowSupplierCreate
